import React, { useRef } from 'react';
import { observer } from 'mobx-react';
import { LatestNewsList } from 'cd-eft/components/common/LatestNews/LatestNews';
import { AboutPage } from 'cd-eft/components/common/About';
import { Roadmap } from 'cd-eft/components/common/Roadmap/Roadmap';
import { GlossaryHelp } from 'cd-eft/components/common/GlossaryHelp/GlossaryHelpPage';
import { AdminContentVM } from './AdminContentVM';
import { TabContent, TabPane } from 'reactstrap';
import { Accordion } from 'cd-eft/components/common/Accordion';
import { Tabs } from 'cd-eft/components/common/Tabs';
import stores from 'cd-eft/models/Stores';
import './AdminContent.scss';

const tabs = [
  { tab: 'release-notes', title: 'Release Notes' },
  { tab: 'Roadmap', title: 'Roadmap' },
  { tab: 'GlossaryHelp', title: 'Glossary/Help' },
];

export const AdminContent = observer(() => {
  const vm = useRef(new AdminContentVM()).current;

  return (
    <div className="admin-content">
      <h1>Admin : Content</h1>

      {stores.AppStore.userProfileStore.applicationFlags.enableadminlatestnews && (
        <LatestNewsList
          adminContent={true}
          collapseNewsCard={vm.clickedCollapseNewsCard}
          newsContainer={vm.collapseNewsCard}
        />
      )}

      <Tabs tabs={tabs} currentTab={vm.selectedSection} onClick={vm.changeTab} />

      <TabContent activeTab={vm.selectedSection}>
        {stores.AppStore.userProfileStore.applicationFlags.enableadminrelease && (
          <TabPane tabId="release-notes">
            {/* Additional Project Details */}
            <AboutPage
              adminContent={true}
              releaseNotes={true}
              collapseButtomCard={vm.clickedCollapseButtomCard}
              buttomContainer={vm.collapseButtomCard}
            />
          </TabPane>
        )}
        {stores.AppStore.userProfileStore.applicationFlags.enableadminroadmap && (
          <TabPane tabId="Roadmap">
            {/* Activity Summary */}
            <Roadmap
              collapseButtomCard={vm.clickedCollapseButtomCard}
              buttomContainer={vm.collapseButtomCard}
            ></Roadmap>
          </TabPane>
        )}
        {stores.AppStore.userProfileStore.applicationFlags.enableadminglossary && (
          <TabPane tabId="GlossaryHelp">
            {/* Project Level - Project Comments */}
            <Accordion className={'p-0 accordion-wrapper accordion-glossary-help'} headers={['Glossary and Help']}>
              <GlossaryHelp
                adminContent={true}
                collapseButtomCard={vm.clickedCollapseButtomCard}
                buttomContainer={vm.collapseButtomCard}
              />
            </Accordion>
          </TabPane>
        )}
      </TabContent>
    </div>
  );
});
